import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 180;

export default makeStyles(theme => ({
  root: {
    display: "flex"
  },
  saldo: {
    float: "right",
    textTransform: "capitalize"
  },
  title: {
    flexGrow: 1
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  menuButtonHidden: {
    display: "none"
  },
  appBarSpacer: theme.mixins.toolbar,
  datosBancarios: {
    fontWeight: "bold",
    lineHeight: 1
  },
  root_tabs: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
}));
